import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '../../../store';
import { initialFilters } from '../features/AnalyticsFilters/utils/filters';
import { AnalyticsFiltersProps } from '../features/AnalyticsFilters/service/filters.interface';

const initialState: AnalyticsFiltersProps = initialFilters;

export const analyticFiltersSlice = createSlice({
    name: 'analyticFilters',
    initialState,
    reducers: {
        setFilters: (state, action: PayloadAction<AnalyticsFiltersProps>) => {
            return action.payload;
        },
        updateFilters: (
            state,
            action: PayloadAction<Partial<AnalyticsFiltersProps>>
        ) => {
            return { ...state, ...action.payload };
        },
        resetFilters: () => initialState,
    },
});

export const { setFilters, updateFilters, resetFilters } =
    analyticFiltersSlice.actions;

export const selectAnalyticsFilters = (state: RootState) =>
    state.analyticFilters;

export const mergeFilters = (
    current: AnalyticsFiltersProps,
    patch: Partial<AnalyticsFiltersProps>
): AnalyticsFiltersProps => ({
    ...current,
    ...patch,
});

export const analyticFiltersReducer = analyticFiltersSlice.reducer;
